
import Vue from 'vue';

// Components
import TextField from '~/components/builders/TextField.vue';

export default Vue.extend({
    name: 'DeleteAccountInput',
    components: { TextField },
    props: {
        match: {
            type: String,
            required: true,
        },
        actionId: {
            type: String,
            default: 'delete-account',
        },
    },
    data() {
        return {
            value: '',
        };
    },
    methods: {
        updateButtonDisabled(disabled: boolean) {
            console.log('updateButtonDisabled', disabled);
            this.$emit('updateDialogContext', {
                disabledActions: {
                    [this.actionId]: disabled,
                },
            });
        },
    },
    mounted() {
        this.updateButtonDisabled(true);
    },
    watch: {
        value(newValue: string) {
            console.log('value', newValue);
            this.updateButtonDisabled(newValue !== this.match);
        },
    },
});
